export const FEATURE_MEMBER_EXPERIENCE =
  process.env.REACT_APP_FEATURE_MEMBER_EXPERIENCE === 'true';

export const FEATURE_NEW_AFFINITY_ONBOARDING =
  process.env.REACT_APP_FEATURE_AFFINITY_REDIRECT_NEW_MEMBER_ONBOARDING === 'true';

export const FEATURE_LIFE_ADDON = process.env.REACT_APP_FEATURE_LIFE_ADDON === 'true';

export const FEATURE_CLAIMS_THANK_YOU_IN_MEMBER_EXP =
  process.env.REACT_APP_FEATURE_CLAIMS_THANK_YOU_IN_MEMBER_EXP === 'true';

export const COMPANY_SIGNUP_URL = process.env.REACT_APP_COMPANY_SIGNUP_URL;
if (!COMPANY_SIGNUP_URL) {
  throw new Error(`env.REACT_APP_COMPANY_SIGNUP_URL must be set`);
}
